import React, { useMemo } from 'react'
import { Button, ButtonGroup } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faClipboardList,
	faGavel,
	faCommentsDollar,
	faCircleCheck,
} from '@fortawesome/free-solid-svg-icons'
import classnames from 'classnames'

/**
 * Seller inventory tabs (client-side grouping over AuctionStateId).
 *
 * Contract:
 * Supports both prop shapes (for backwards compatibility):
 * - value / onChange
 * - activeTab / onTabChange
 *
 * Where the value is one of: 'pending' | 'auction' | 'bid-review' | 'sold'
 */
const SellerInventoryTabs = (props) =>
{
	const value = props.value ?? props.activeTab
	const onChange = props.onChange ?? props.onTabChange
	const counts = props.counts
	// Pending sub-filter removed; keep backwards compatibility for props but ignore them.

	const tabs = useMemo(() => (
		[
			{ key: 'pending', label: 'Pending', icon: faClipboardList },
			{ key: 'auction', label: 'Auction', icon: faGavel },
			{ key: 'bid-review', label: 'Bid Review', icon: faCommentsDollar },
			{ key: 'sold', label: 'Sold', icon: faCircleCheck },
		]
	), [])

	// pendingFilters removed

	const labelWithCount = (key, label) =>
	{
		if (!counts || typeof counts[key] !== 'number') return label
		return `${label} (${counts[key]})`
	}

	return (
		<div style={{ width: '100%' }}>
			<div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
				<ButtonGroup>
					{tabs.map((tab) => (
						<Button
							key={tab.key}
							color="primary"
							outline
							onClick={() => typeof onChange === 'function' && onChange(tab.key)}
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: value === tab.key })
							}
						>
							<FontAwesomeIcon icon={ tab.icon } /> {labelWithCount(tab.key, tab.label)}
						</Button>
					))}
				</ButtonGroup>
			</div>


			{/* BRD alignment: only Parent Tabs + Status filter. Pending sub-filter removed. */}
		</div>
	)
}

export default SellerInventoryTabs
